import { Injectable } from "@angular/core";
import { DocumentState } from "../core/document-list/models/documentState";
import { BuildingSurveyViewModel } from "./Models/buildingTableViewModel";
import { SurveyStatus } from "./Models/enums/SurveySurveyStatus";
import { InsideSurvey } from "./Models/read";
import { ExistingLomBuildingDto } from "./Models/read/ExistingLomBuildingDto";

@Injectable({
  providedIn: "root",
})
export class TsaRemovalService {
  constructor() {}

  getRemarkForBuildingSurveyViewModel(
    building: BuildingSurveyViewModel,
    baseText: string
  ): string {
    return baseText;
  }

  getRemarkForBuildingSurveyViewModels(
    buildings: BuildingSurveyViewModel[],
    baseText: string
  ): string {
    return baseText;
  }

  getRemarkForInsideSurvey(survey: InsideSurvey, baseText: string): string {
    return baseText;
  }

  getRemarkForExistingLomBuilding(
    building: ExistingLomBuildingDto,
    baseText: string
  ): string {
    return baseText;
  }
}
